var alertTriggerToggle = {
	add: "Trigger hinzufügen",
	edit: "Trigger bearbeiten",
	label: {
		addAlert: "Alert hinzufügen",
		upperLimit: "Obergrenze",
		lowerLimit: "Untergrenze",
		upperLimitCrossed: "Oberes Limit überschritten",
		lowerLimitCrossed: "Unteres Limit unterschritten"
	}
};
var de = {
	alertTriggerToggle: alertTriggerToggle
};

export { alertTriggerToggle, de as default };
